<template>
  <!-- begin:: Footer -->
  <div class="footer py-4 d-flex flex-lg-column" id="kt_footer">
    <div
      class="container d-flex align-items-center"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="footer-logo">
        <img :src="require('@/assets/images/logo.png')">
      </div>
      <div class="text-white footer-text">
        <span class="font-weight-400">
          &nbsp;&copy;&nbsp;EMMA Todos los derechos reservados. All rights reserved.
        </span>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  mounted() {
    
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
